import { render, staticRenderFns } from "./RegistryById.vue?vue&type=template&id=407ff69a&scoped=true&"
import script from "./RegistryById.vue?vue&type=script&lang=js&"
export * from "./RegistryById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ff69a",
  null
  
)

export default component.exports